import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=c0a825a0&scoped=true&"
import script from "./Branches.vue?vue&type=script&lang=js&"
export * from "./Branches.vue?vue&type=script&lang=js&"
import style0 from "./Branches.vue?vue&type=style&index=0&id=c0a825a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a825a0",
  null
  
)

export default component.exports